/* eslint-disable @typescript-eslint/no-non-null-asserted-optional-chain */
import React from "react";
import { IonButton, IonImg, IonSpinner } from "@ionic/react";
import DetailsContentCollapsible from "@components/programs/DetailsContentCollapsible";
import { useHistory, useParams } from "react-router";
import { useProgramData } from "@hooks/data/useProgramData";
import { useRecoilValueLoadable } from "recoil";
import { IExportType, IUser } from "@interfaces/Interfaces";
import { userAtom } from "@state/State";
import * as ProgramUtils from "@utils/programUtils";
import { Icon_Export_Blue, Icon_Pencil } from "@assets/images";
import { ILasDetailsProps } from "@interfaces/Components";

function LasDetails(props: ILasDetailsProps) {
  const history = useHistory();
  const params = useParams<{ programId: string }>();

  const { userPrograms } = useProgramData();

  const program = userPrograms.find((p) => p.ID === params.programId)!;

  const user = useRecoilValueLoadable<IUser | null>(userAtom);

  return (
    <DetailsContentCollapsible
      title={user && user.state === "hasValue" ? user.contents?.name! : ""}
      program={program}
    >
      {!!ProgramUtils.mapESRNumber(program, user.contents?.subscriptions) && (
        <div className="mb-[4px] mt-[8px]">
          <div className="text-acc-13px leading-[1.54] tracking-[-0.1px] text-grey-70">Your ESR</div>
          <div className="text-acc-17px leading-[1.53] tracking-[-0.3px] text-grey-90">
            {ProgramUtils.mapESRNumber(program, user.contents?.subscriptions)}
          </div>
        </div>
      )}
      <div className="mb-[4px] mt-[8px]">
        <div className="text-acc-13px leading-[1.54] tracking-[-0.1px] text-grey-70">Your role</div>
        <div className="text-acc-17px leading-[1.53] tracking-[-0.3px] text-grey-90">
          {ProgramUtils.getUsersRole(user.contents, program.ID)}
        </div>
      </div>
      <div className="mb-[4px] mt-[8px]">
        <div className="text-acc-13px leading-[1.54] tracking-[-0.1px] text-grey-70">Your team</div>
        <div className="text-acc-17px leading-[1.53] tracking-[-0.3px] text-grey-90">
          {ProgramUtils.getUsersTeam(user.contents, program.ID)}
        </div>
      </div>
      {ProgramUtils.isClinicalAdvisor(program.ID) && (
        <div className="mb-[4px] mt-[8px]">
          <div className="text-acc-13px leading-[1.54] tracking-[-0.1px] text-grey-70">Your Course ID</div>
          <div className="text-acc-17px leading-[1.53] tracking-[-0.3px] text-grey-90">
            {ProgramUtils.getUsersCourseId(user.contents, program.ID)}
          </div>
        </div>
      )}
      <div className="mt-3 flex gap-2">
        <IonButton
          className="program-card-button h-[50px] flex-1"
          onClick={() => props.exportPressed(IExportType.PROGRAM, program)}
        >
          {props.exportingEvidence && props.currentExportType === IExportType.PROGRAM ? (
            <IonSpinner className="text-cta-blue" />
          ) : (
            <>
              <IonImg
                className="h-[40px] w-[40px]"
                src={Icon_Export_Blue}
              />
              <div className="text-[16px] font-semibold text-cta-blue">{"Download"}</div>
            </>
          )}
        </IonButton>
        <IonButton
          className="program-card-button h-[50px] flex-1"
          onClick={() => history.push(`/dashboard/program/${program.ID}/role-team-setup`)}
        >
          <IonImg
            className="mr-1 h-[24px] w-[24px]"
            src={Icon_Pencil}
          />
          <div className="text-[16px] font-semibold text-cta-blue">Edit</div>
        </IonButton>
      </div>
    </DetailsContentCollapsible>
  );
}

export default LasDetails;
